<template>
  <div  v-if="hasLocation"
        class="jlr-number-item-style">
    <span>{{ this.loc.ClientLocationIdOnClientSite }}</span>
  </div>
</template>

<script>
export default {
  beforeMount() {
    if (this.params.data) {
      this.loc = this.params.data;
    } else if (this.params.node.group) {
      const regex = /___(\d+)$/;
      if (this.params.node.level === 0) {
        let number = this.params.node.key.match(regex) ? this.params.node.key.match(regex)[1] : undefined;
        this.loc = this.params.context.getLocation(parseInt(number));
      } else if (this.params.node.level === 1) {
        let number = this.params.node.parent.key.match(regex) ? this.params.node.parent.key.match(regex)[1] : undefined;
        this.loc = this.params.context.getLocation(parseInt(number));
      }
    }
  },

  computed: {
    hasLocation() {
      return !!this.loc;
    }
  }
}
</script>

<style >
  .jlr-number-item-style  {
    line-height: 1.5rem!important; 
    padding-top: 10px!important; 
    padding-bottom: 10px!important;
    text-align: left; 
    text-align: -webkit-left;
  }
  
  .jlr-number-item-style div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

</style>